import {GET_STORE_DESIGN}  from "./../../AppConfig"; 


const initialState={
    storeDesign:{}
}

export default function(state=initialState, action){
   
    switch(action.type){        
        case GET_STORE_DESIGN:
            return{                
                ...state,
                storeDesign:action.payload,
            }
        default:             
        return state;
       
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/designReducer.js